import { gql } from '@apollo/client'

export default gql(`
query adminListPaymentTransactions( $subscriptionId: String!) {
    adminListPaymentTransactions( 
        subscriptionId: $subscriptionId
    ) {
        billingItemId
        itChargeId
        subscriptionStartDate
        subscriptionEndDate
        actualChargeDate
        expectedChargeDate
        paymentStatus
        amount
        latestITErrorPayload
    }
}`)
